import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { ArgoxLogo } from '../components/brand/ArgoxLogo';
import { api } from '../services/api';
import '../styles/register.css';

export function CheckoutSuccessPage() {
  const { loading, session, token, refresh, logout } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Confirmando tu pago con Stripe…');
  const sessionId = params.get('session_id');

  useEffect(() => {
    if (!token || !sessionId) return;
    let cancelled = false;
    let timer: number | undefined;
    async function confirm(attempt = 0) {
      try {
        const result = await api<{ paid: boolean; active: boolean }>('/checkout/status?session_id=' + encodeURIComponent(sessionId!), token);
        if (cancelled) return;
        if (result.paid && result.active) {
          setMessage('Pago confirmado. Preparando tu negocio…');
          await refresh();
          if (cancelled) return;
          navigate('/panel', { replace: true });
          return;
        }
        if (attempt >= 6) setMessage(result.paid ? 'Pago confirmado. Estamos preparando tu negocio…' : 'Stripe sigue confirmando el pago…');
      } catch (failure) {
        if (cancelled) return;
        if (failure instanceof Error && failure.message.includes('no corresponde')) {
          logout();
          navigate('/login?activated=1', { replace: true });
          return;
        }
        if (attempt >= 6) setMessage('Estamos retomando la conexión…');
      }
      if (!cancelled) timer = window.setTimeout(() => void confirm(attempt + 1), 2000);
    }
    void confirm();
    return () => { cancelled = true; if (timer) window.clearTimeout(timer); };
  }, [logout, navigate, refresh, sessionId, token]);

  if (loading) return <div className="route-loading">Consultando tu sesión…</div>;
  if (!session) return <Navigate to="/login" replace />;
  if (!sessionId) return <Navigate to="/" replace />;
  return <main className="checkout-result"><ArgoxLogo /><div className="checkout-spinner" /><h1>Estamos activando Argox.</h1><p>{message}</p><small>Al terminar entraremos al panel automáticamente.</small></main>;
}
